// extracted by mini-css-extract-plugin
module.exports = {"action":"search_filters_bar_action-module__action--2brdW"};